import { KeyValue } from '@/main/models/common';
import {
  CompanyManufacturerActionTypes,
  CompanyManufacturerTypes
} from './companyManufacturerTypes';
import { CompanyManufacturerRequest } from '@/main/models/request/companyManufacturerRequest';

export function getCompanyManufacturer(
  request: CompanyManufacturerRequest
): CompanyManufacturerActionTypes {
  return {
    type: CompanyManufacturerTypes.GET_COMPANY_MANUFACTURER,
    payload: { request }
  };
}

export function saveCompanyManufacturer(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null
): CompanyManufacturerActionTypes {
  return {
    type: CompanyManufacturerTypes.SAVE_COMPANY_MANUFACTURER,
    payload: { data, isError, errorMessages }
  };
}

export function resetReducerCompanyManufacturer(): CompanyManufacturerActionTypes {
  return {
    type: CompanyManufacturerTypes.RESET_REDUCER_COMPANY_MANUFACTURER
  };
}
